import type { SettlementDetail } from '@services/settlements/types'
import type { UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { SettlementMeterUsageCard } from '../SettlementMeterUsageCard'
import { DateField, MoneyField, StepIntro } from './fields'
import type { SettlementFormValues } from './useSettlementInputsForm'

export function StepElectricity({
  settlement,
  form,
  readOnly
}: {
  settlement: SettlementDetail
  form: UseFormReturn<SettlementFormValues>
  readOnly: boolean
}) {
  const { t } = useTranslation('settlement')

  return (
    <div className="space-y-4">
      <StepIntro>{t('wizard.electricity.intro')}</StepIntro>

      <SettlementMeterUsageCard
        settlement={settlement}
        readOnly={readOnly}
        blocks={['ELECTRICITY']}
        embedded
      />

      <div className="rounded-2xl border border-ink/[0.08] p-4">
        <h3 className="m-0 mb-3 font-display text-base font-bold text-ink">
          {t('sections.electricity')}
        </h3>
        <div className="grid gap-4 sm:grid-cols-2">
          <MoneyField
            name="electricity_annual_consumption_cost"
            label={t('fields.annual_consumption_cost')}
            hint={t('hints.electricity_consumption')}
            suffix="€"
            register={form.register}
          />
          <MoneyField
            name="electricity_annual_fixed_cost"
            label={t('fields.annual_fixed_cost')}
            hint={t('hints.electricity_fixed')}
            suffix="€"
            register={form.register}
          />
          <MoneyField
            name="electricity_annual_kwh"
            label={t('fields.annual_kwh')}
            hint={t('hints.electricity_kwh')}
            suffix="kWh"
            register={form.register}
          />
          <div />
          <DateField
            name="electricity_bill_period_start"
            label={t('fields.bill_period_start')}
            hint={t('hints.bill_period')}
            clearable
            control={form.control}
          />
          <DateField
            name="electricity_bill_period_end"
            label={t('fields.bill_period_end')}
            clearable
            control={form.control}
          />
        </div>
      </div>
    </div>
  )
}
